import React from 'react';

import {LinkButton} from "../../misc/buttons/link-button";
import {Image} from "../../image/image";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {AllScoresLinkModel} from "../../../../containers/all-scores-container/models/all-scores-container-link-model";
import {SPORT_TYPES} from "../../../app/consts";

export class ScoresMobileLiveEmptyStateComponentProps extends BaseProps {
  text: String;
  buttonText: String;
  linkModel: AllScoresLinkModel;
  ImageSrc: String;
  onClick: Function;
}

export const ScoresMobileLiveEmptyState = ({text, buttonText, linkModel, ImageSrc, onClick}: ScoresMobileLiveEmptyStateComponentProps) => {

  return (
    <div className={'scores-list-widget-mobile-live-empty-state'}>
      <Image src={new ImageSrc(82, 42, SPORT_TYPES.onTv)}
             className={'scores-list-widget-mobile-live-empty-state-image'}/>
      <div className={'scores-list-widget-mobile-live-empty-state-text'}>{text}</div>
      <LinkButton linkModel={linkModel} className={'scores-list-widget-mobile-live-empty-state-button'}
                  label={buttonText} enabled={true} onClick={onClick}/>
    </div>
  )
}
